import { h } from 'preact';
import cx from 'classnames';

import style from './style.less';


/** A top border used as a separator
 */
export const TopBorder = ({ theme }) => 	<hr class={cx(style.topBorder, style[theme])} />;
